<template>
  <VueFragment>
    <SiteHeader />
    <div class="router-view">
      <router-view></router-view>
    </div>
    <SiteFooter />
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

import SiteFooter from './components/SiteFooter.vue';
import SiteHeader from './components/SiteHeader.vue';

export default {
  name: 'App',
  components: {
    VueFragment,
    SiteFooter,
    SiteHeader
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: Heebo;
  src: url('./assets/fonts/Heebo-Regular.ttf');
}

@font-face {
  font-family: Heebo;
  src: url('./assets/fonts/Heebo-Bold.ttf');
  font-weight: bold;
}

html, body {
  height: 100%;
}

#app {
  font-family: 'Heebo', sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100%;
  margin-top: 56px;
  display: flex;
  flex-direction: column;

  .router-view {
    flex: 1 0 auto;
  }
}

h1, h2, h3 {
  text-transform: uppercase;
}

a {
  text-decoration: none !important;

  &:hover {
    text-decoration: none;
  }
}

.disable-text-select {
  -webkit-touch-callout: none;  /* iOS Safari */
  -webkit-user-select: none;    /* Safari */
  -khtml-user-select: none;     /* Konqueror HTML */
  -moz-user-select: none;       /* Old versions of Firefox */
  -ms-user-select: none;        /* Internet Explorer/Edge */
  user-select: none;            /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>
